"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get OrganizationInvite () {
        return OrganizationInvite;
    },
    get default () {
        return _default;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _components = require("@react-email/components");
const _components1 = require("~/services/mail/templates/components");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const OrganizationInvite = ({ name, email, link })=>/*#__PURE__*/ _react.createElement(_components.Html, null, /*#__PURE__*/ _react.createElement(_components1.RootWrapper, null, /*#__PURE__*/ _react.createElement(_components.Head, null), /*#__PURE__*/ _react.createElement(_components.Preview, null, "You’ve been invited to NocoDB"), /*#__PURE__*/ _react.createElement(_components.Body, {
        className: "bg-white"
    }, /*#__PURE__*/ _react.createElement(_components1.ContentWrapper, null, /*#__PURE__*/ _react.createElement(_components.Heading, {
        className: "text-gray-900 text-center font-bold m-auto text-xl md:text-2xl"
    }, "You’ve been invited to NocoDB"), /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "text-gray-600 text-center !my-6 text-sm"
    }, /*#__PURE__*/ _react.createElement("span", {
        className: "font-bold text-gray-800"
    }, name), " ( ", email, ") has invited you to collaborate on NocoDB."), /*#__PURE__*/ _react.createElement(_components.Button, {
        className: "text-center w-full text-base font-bold bg-brand-500 text-white rounded-lg h-10",
        href: link
    }, /*#__PURE__*/ _react.createElement(_components.Text, {
        className: "!my-[8px]"
    }, "Go to NocoDB"))), /*#__PURE__*/ _react.createElement(_components1.Footer, null))));
OrganizationInvite.PreviewProps = {
    name: 'John Doe',
    email: 'johndoe@gmail.com',
    link: 'https://nocodb.com'
};
const _default = OrganizationInvite;
